module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Timespan":"Zeitraum","This month":"Dieser Monat","Last month":"Letzter Monat","Last 3 months":"Letzte 3 Monate","This year":"Dieses Jahr","Start date":"Startdatum","End date":"Enddatum"}}')
  delete Component.options._Ctor
}
